export function isGroupSelectable(firmRef: string | null): boolean {
  return firmRef !== null && firmRef !== "";
}

export type MoveToFirmBody = {
  userId: string;
  firmRef: string;
  firmName: string;
  fromFirmRefs?: string[];
};

export function buildMoveToFirmBody(params: {
  userId: string;
  firmRef: string;
  firmName: string;
  scoped: false;
  selectedFirmRefs: (string | null)[];
}): MoveToFirmBody;
export function buildMoveToFirmBody(params: {
  userId: string;
  firmRef: string;
  firmName: string;
  scoped: boolean;
  selectedFirmRefs: (string | null)[];
}): MoveToFirmBody | null;
export function buildMoveToFirmBody(params: {
  userId: string;
  firmRef: string;
  firmName: string;
  scoped: boolean;
  selectedFirmRefs: (string | null)[];
}): MoveToFirmBody | null {
  const body: MoveToFirmBody = {
    userId: params.userId,
    firmRef: params.firmRef,
    firmName: params.firmName,
  };

  if (params.scoped) {
    const fromFirmRefs = params.selectedFirmRefs.filter((ref): ref is string =>
      isGroupSelectable(ref),
    );

    if (fromFirmRefs.length === 0) {
      return null;
    }

    body.fromFirmRefs = fromFirmRefs;
  }

  return body;
}
